import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { circeWithText } from '../styles/styles'
import { checkCoordinateIsValid } from '../helpers/helpers'
import * as _ from 'lodash'

export class BeaconFeature {
  constructor(
    map,
    imageWidthInPixels,
    imageHeightInPixels,
    beacon,
    type,
    userDefinedStyles,
    batteryColors
  ) {
    // this check will check all the required parameters and
    // that they are not false, null, 0 or ""
    if (!imageWidthInPixels || !imageHeightInPixels ||
      !beacon || !type) {
      return null
    }

    if (!checkCoordinateIsValid(beacon.kx) || !checkCoordinateIsValid(beacon.ky)) {
      return null
    }
    this.map = map;
    this.type = type;
    this.objectType = 8;
    this.beacon = beacon;
    this.coordinates = [
      beacon.kx * imageWidthInPixels,
      beacon.ky * imageHeightInPixels]

    this.openLayersFeature = new Feature({
      type,
      payload: this,
      geometry: new Point(this.coordinates),
    });

    this.openLayersFeature.setId(beacon.id);
    this.openLayersFeature.setStyle(this.createBeaconStyle(beacon, userDefinedStyles, batteryColors));
    return this.openLayersFeature;
  }

  setStyles(style) {
    this.openLayersFeature.setStyle(style);
  }

  updateCoord(){
    const { kx, ky } = this.beacon;
    if (!checkCoordinateIsValid(kx) || !checkCoordinateIsValid(ky)) {
      return;
    }

    this.coordinates = getPosition({
      kx,
      ky,
      mapProps: this.map.mapProps,
      extent: this.map.extentMap
    }, this.map.modes.globalMap);
    const geometry = this.openLayersFeature.getGeometry();
    geometry.setCoordinates(this.coordinates);
  }

  // create circle with text style
  createBeaconStyle(beacon, userDefinedStyles, batteryColors = false) {
    const defaultOptions = {
      inActiveColor: '#a8adaa',
      lowBatteryColor: '#cc1011',
      mediumBatteryColor: '#e79c20',
      hightBattetyColor: '#89af68',
      lowBatteryPercentage: 30,
      mediumBatteryPercentage: 70,
      lowBatteryDays: 15,
      batteryColors: false
    };
    let color = batteryColors ? defaultOptions.inActiveColor : '';
    if (batteryColors) {
      const nowDate = new Date();
      const dateLastUpdate = new Date(beacon.last_bt_update);
      const daysDivider = 1000 * 60 * 60 * 24;

      if (beacon.last_bt_update) {
        const daysDiff = Math.ceil(Math.abs(dateLastUpdate.getTime() - nowDate.getTime()) / daysDivider);
        if (beacon.bt && (daysDiff < defaultOptions.lowBatteryDays)) {
          if (beacon.bt < defaultOptions.lowBatteryPercentage) {
            color = defaultOptions.lowBatteryColor;
          }
          if (beacon.bt > defaultOptions.lowBatteryPercentage &&
            beacon.bt < defaultOptions.mediumBatteryPercentage) {
            color = defaultOptions.mediumBatteryColor;
          }
          if (beacon.bt > defaultOptions.mediumBatteryPercentage) {
            color = defaultOptions.hightBattetyColor;
          }
        }
      }
    }

    const defaultStyles = {
      text: {
        text: 'B',
        stroke: {
          width: 0.9
        },
        background: {
          fill: {
            color: ''
          },
          stroke: {
            color: '',
            width: 1
          }
        }
      },
      circle: {
        radius: 12,
        fill: {
          color: '#a8adaa',
        },
        stroke: {
          color: '#a8adaa'
        }
      }
    }

    let styles = defaultStyles;

    if (userDefinedStyles && typeof userDefinedStyles === 'object') {
      styles = _.merge({}, defaultStyles, userDefinedStyles)
    }


    return circeWithText(styles);
  }
}
